<template>
  <div id="content" class="text-left">
    <h1>Mon diagnostic gaspillage</h1>
    <v-form ref="form" v-model="formIsValid" id="diagnostic-form" @submit.prevent class="mb-4">
      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">Avez-vous mesuré le gaspillage alimentaire dans votre cantine ?</h2>
          <DsfrRadio
            v-model="diagnostic.foodWasteMeasurement"
            :items="[
              { value: 'Oui', label: 'Oui' },
              { value: 'Non', label: 'Non' },
            ]"
            label="Sélectionnez une option"
            hide-details
            class="text-left"
          />
        </v-col>
      </v-row>

      <v-row class="mt-2" v-if="diagnostic.foodWasteMeasurement === 'Oui '">
        <v-col cols="12">
          <h2 class="mb-2 text-left">Quel est le pourcentage de gaspillage alimentaire mesuré ?</h2>
          <DsfrTextField
            v-model.number="diagnostic.wastePercentage"
            label="Entrez le pourcentage"
            append-icon="mdi-percent"
            :rules="[validators.isPercentageOrEmpty]"
            class="text-left"
          />
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">Avez-vous mis en place un plan de réduction du gaspillage alimentaire ?</h2>
          <DsfrRadio
            v-model="diagnostic.wasteReductionPlan"
            :items="[
              { value: 'Oui', label: 'Oui' },
              { value: 'Non', label: 'Non' },
            ]"
            label="Sélectionnez une option"
            hide-details
            class="text-left"
          />
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">
            Avez-vous mené des actions de sensibilisation contre le gaspillage alimentaire ?
          </h2>
          <DsfrRadio
            v-model="diagnostic.awarenessActions"
            :items="[
              { value: 'Oui', label: 'Oui' },
              { value: 'Non', label: 'Non' },
            ]"
            label="Sélectionnez une option"
            hide-details
            class="text-left"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-btn large color="primary" @click="submitDiagnostic" :disabled="!formIsValid" class="my-8">
          Soumettre
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import DsfrRadio from "@/components/DsfrRadio"
import validators from "@/validators"

export default {
  name: "WasteDiagnosticPage",
  components: {
    DsfrRadio,
  },
  data() {
    return {
      diagnostic: {
        foodWasteMeasurement: "",
        wastePercentage: null,
        wasteReductionPlan: "",
        awarenessActions: "",
      },
      formIsValid: true,
    }
  },
  methods: {
    submitDiagnostic() {
      console.log("Diagnostic soumis :", this.diagnostic)
      // Ajoutez ici la logique pour traiter les données du diagnostic
    },
  },
  computed: {
    validators() {
      return validators
    },
  },
}
</script>

<style scoped>
#content {
  width: 210mm;
}

#diagnostic-form {
  display: flex;
  flex-direction: column;
  align-items: left;
  max-width: 1500px !important;
  margin: auto;
}

h2 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.text-left {
  text-align: left;
}

@media (max-width: 210mm) {
  #content {
    width: 100%;
  }
}
</style>
